import { useState } from "react"
import { DetailPage } from "../../components/crud/DetailPage"
import { Badge, ListPage } from "../../components/crud/ListPage"
import { Checkbox, PasswordInput, Select, TextInput } from "../../components/forms/Inputs"
import { useParams } from "react-router-dom"
import { useTranslations } from "../../layers/Localization"

export const useRoleOptions = () => {
    const t = useTranslations()
    return [
        { value: 'admin', label: t('Admin'), color: 'darkviolet' },
    ]
}

function UserFields({ item, set }) {
    const [changePassword, setChangePassword] = useState(false)
    const t = useTranslations()
    const isNew = useParams().id === 'new'

    if (!changePassword && !isNew && item.password !== undefined) set('password')(undefined)
    return <>
        <TextInput label={t("Email")} value={item.email} onChange={set('email')} required />
        <Select label={t("Role")} value={item.role} onChange={set('role')} options={useRoleOptions()} required />
        {!isNew && (<Checkbox value={changePassword} onChange={setChangePassword} label={t("Change password")} />)}
        {(changePassword || isNew) && <PasswordInput label={t("Password")} value={item.password} onChange={set('password')} required />}
    </>
}

export function UsersList(props) {
    const t = useTranslations()
    const roleOptions = useRoleOptions()
    return <ListPage model="users" title={t("Users")} columns={{
        [t('Email')]: 'email',
        [t('Role')]: { sort: 'role', value: item => <Badge value={item.role} options={roleOptions} /> },
    }} {...props} />
}

export function UserDetail(props) {
    const t = useTranslations()
    return <DetailPage model="users" title={t("User")} Fields={UserFields} {...props} />
}
